import type { FaireProductEntity } from "../../entity_types/product";

export const p_a5wspxmrpf: FaireProductEntity = {
  token: "p_a5wspxmrpf",
  type: "product",
  name: 'Classic Bottle with Stopper-Clear-10"H(36oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/b6b8d4eaf168c35eecadf0a690a18759c595c7e9892022949e7cd0494d10601d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1636850ba3010dde229e472720ea97c7a0d9686ff62fa9d4ce30d6e14b6860ee.jpeg",
  ],
  priceDollars: 11,
  description:
    "Introducing our Classic Bottle with Stopper in clear glass, a versatile and elegant vessel. Crafted with high-quality glass, this bottle features a classic design with a sleek silhouette and a secure stopper, adding a touch of sophistication to your hydration.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:08.753Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
